import { post } from "./api.ts";

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export type DownloadResult = { saved: string[]; failed: { assetId: string; reason: string }[] };

/**
 * Starts a browser download for each original, one at a time (browsers block a burst of
 * programmatic downloads). A recording that is not verified yet is reported, not skipped silently,
 * so an editor never assumes a batch is complete when it is not.
 */
export async function downloadOriginals(
  tripId: string,
  items: { assetId: string; componentKey: string }[],
  onProgress: (done: number, total: number) => void = () => undefined,
): Promise<DownloadResult> {
  const out: DownloadResult = { saved: [], failed: [] };
  for (const [i, it] of items.entries()) {
    try {
      const g = await post<{ url: string }>(`/v1/trips/${tripId}/media-grants`, {
        download: true,
        reference: { kind: "ASSET_COMPONENT", assetId: it.assetId, componentKey: it.componentKey },
      });
      const a = document.createElement("a");
      a.href = g.url;
      a.rel = "noopener";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
      out.saved.push(it.assetId);
      await sleep(900);
    } catch (e) {
      out.failed.push({ assetId: it.assetId, reason: (e as Error).message });
    }
    onProgress(i + 1, items.length);
  }
  return out;
}
